import type { CSSProperties } from "react";
import { InProgressSpinner } from "./InProgressSpinner";

interface SolvysLoaderProps {
  /** Accessible status label. Omit for inline-only use. */
  text?: string;
  /** Glyph size in px. Default 14. */
  size?: number;
  /** Override color. Defaults to var(--fintheon-accent). */
  color?: string;
  className?: string;
  style?: CSSProperties;
}

export function SolvysLoader({
  text,
  size = 14,
  color,
  className,
  style,
}: SolvysLoaderProps) {
  return (
    <InProgressSpinner
      size={size}
      color={color ?? "var(--fintheon-accent)"}
      label={text}
      className={className}
      style={style}
    />
  );
}

/** Full-center variant for page / panel loading states. */
export function SolvysLoaderCentered({
  text = "Loading…",
  size = 18,
  color,
  className,
  style,
}: SolvysLoaderProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-3 py-12${className ? ` ${className}` : ""}`}
      style={style}
    >
      <SolvysLoader size={size} color={color} text={text} />
    </div>
  );
}
